<template>
    <div class="table-container">
        <el-table
            :data="demands"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    {{props.row.brief||'-暂无简介-'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="domain.name"
                label="分类"
                show-overflow-tooltip
                width="120"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="名称"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="company.name"
                label="公司"
                show-overflow-tooltip
                max-width="280"
            >
            </el-table-column>
            <el-table-column
                prop="cycle"
                label="研发周期"
                max-width="180"
            ></el-table-column>
            <el-table-column
                prop="budget"
                show-overflow-tooltip
                label="预算"
                max-width="180"
            ></el-table-column>
            <el-table-column
                prop="contact"
                label="联系人"
                show-overflow-tooltip
            >
            <template slot-scope="props">
                <span v-if="props.row.contact">
                    {{props.row.contact}}({{props.row.phone||'-无电话号码-'}})
                </span>
                <span v-else>
                    {{props.row.company.contact}}({{props.row.company.phone||'-无电话号码-'}})
                </span>
            </template>
            </el-table-column>
            <el-table-column
                prop="created_at"
                width="160"
                label="创建时间"
                align="center"
                :formatter="unixFormatter"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <el-button
                        @click="edit(scope.row)"
                        type="text"
                        size="mini"
                    >编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <ox-safe-button
                        @confirm="remove(scope.row)"
                        type="text"
                        size="small"
                    >删除</ox-safe-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="onPageChange"
                :page-size="pagination.size"
                :current-page="pagination.current"
                :total="pagination.total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { pageMixin, fmtMixin } from "@/ox/Mixins";
import OxSafeButton from '@/ox/components/OxSafeButton';

export default {
    name: "ProductTable",
    mixins: [pageMixin, fmtMixin],
    components:{
        OxSafeButton
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            demands: []
        };
    },

    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.isLoading = true;
            const currentPage = page || this.page;
            const query = new window.BaaS.Query();
            const {filter} = this.$parent;
            if(filter.domain){
                query.compare('domain', '=', filter.domain);
            }
            if(filter.company){
                query.compare('company', '=', filter.company);
            }
            if(filter.keyword){
                query.contains('name', filter.keyword);
            }
            this.$ox
                .service("demand")
                .find(query, {
                    page: currentPage,
                    withCount: true,
                    expand:['domain', 'company'],
                    orderBy: ["-created_at"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.pagination.size = res.meta.limit;
                    this.pagination.total = res.meta.total_count;
                    this.pagination.current = currentPage;
                    this.page = currentPage;
                    this.demands = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        onPageChange(page) {
            this.loadData(page);
        },
        edit(row) {
            this.$parent.$refs.dialog.show(row)
        },
        remove(row){
            this.$ox.service('demand').delete(row.id).then(()=>{
                this.demands = this.demands.filter(demand=>demand.id!==row.id)
                this.$notify.success({
                    title: '操作成功',
                    message: `需求"${row.name}"已删除`
                });
            })
        }
    }
};
</script>

<style scoped>
.name{
    display: flex;
    justify-content:flex-start;
    align-items:center;
}
.name i{
    font-size:16px;
    color: #409EFF;
    display: inline-block;
    flex-shrink:0;
    flex-grow:0;
    margin-left:5px;
    cursor: pointer;
    vertical-align:middle;
    line-height:21px;
}
</style>
